<template>
  <div id="app">
    <Header/>
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    'Header': Header,
    'Footer': Footer
  }
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@300&display=swap');
#app {
  font: W6 25px/40px Hiragino Mincho ProN;
  font-family: 'Noto Serif JP', serif;
  color: #2c3e50;
  letter-spacing: 0.8px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue